import { useI18nStore } from '~/stores/i18n'

export default defineNuxtPlugin(async (nuxtApp) => {
  const store = useI18nStore()

  // 서버에서만 init() 실행. 클라이언트는 @pinia/nuxt가 전달한 SSR 상태를 그대로 사용.
  // 클라이언트에서 hydration 이전에 store.init()을 호출하면 localStorage locale이
  // 서버 렌더링 locale과 달랐을 때 메시지가 바뀌어 hydration mismatch가 발생한다.
  if (import.meta.server) {
    await store.init()
  }

  if (import.meta.client) {
    nuxtApp.hook('app:mounted', async () => {
      const savedLocale = localStorage.getItem('locale') ?? store.locale

      // 1. API에서 최신 번역 로드 (SSR 캐시 파괴)
      store.loaded[savedLocale] = false
      await store.setLocale(savedLocale)

      // 2. 정적 JSON(/locales/{lang}.json)으로 API 누락 키 보충 — 초기 마운트 1회만 실행.
      //    triggerExport()는 DB→파일 방향이므로 동기화 후에는 파일도 DB와 동일해져
      //    이 gap-fill의 효과가 사라진다. refreshAllLoaded()는 이 경로를 거치지 않으므로
      //    동기화 버튼 클릭 후 동작(API-only)에 영향을 주지 않는다.
      try {
        const staticMsgs = await $fetch<Record<string, string>>(
          `/locales/${savedLocale}.json`,
          { params: { _t: Date.now() } }
        )
        // API 데이터 우선(오른쪽 spread); 정적 파일은 DB에 없는 키만 채움
        store.messages[savedLocale] = { ...staticMsgs, ...store.messages[savedLocale] }
      } catch {
        // 정적 파일 없으면 무시
      }
    })
  }

  const $t = (key: string, params?: Record<string, string | number> | (string | number)[]) =>
    store.t(key, params)

  nuxtApp.vueApp.config.globalProperties.$t = $t

  return { provide: { t: $t } }
})
